/**
 * Function to safely call Reddit Pixel tracking
 * @param {string} event_type - The type of event to track (e.g., 'Purchase', 'PageVisit')
 * @param {Object} custom_data - Additional data to send with the event
 */
export const trackRedditEvent = (event_type, custom_data = {}) => {
    if (window.rdt) {
        if (Object.keys(custom_data).length === 0) {
            window.rdt('track', event_type);
        } else {
            window.rdt('track', event_type, custom_data);
        }
    } else {
        console.error("rdt() not found");
    }
};

export const trackGoogleEvent = (event_type, custom_data = {}) => {
    if (window.gtag) {
        window.gtag('event', event_type, custom_data);
    } else {
        console.error("gtag() not found");
    }
};


export const trackLinkedInEvent = (custom_data = {}) => {
    if (window.lintrk) {
        window.lintrk('track', custom_data);
    } else {
        console.error("lintrk() not found");
    }
};
